var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 50,
    viewBox: "0 0 59 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1010105640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 634054"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 6",
    d: "M43.9181 39.9181C47.2643 36.5719 49.3468 32.1689 49.8106 27.4594C50.2744 22.75 49.091 18.0253 46.4619 14.0906C43.8328 10.1559 39.9207 7.25447 35.3922 5.88077C30.8637 4.50706 25.999 4.74605 21.6269 6.55701C17.2549 8.36797 13.646 11.6389 11.4152 15.8123C9.18447 19.9858 8.46981 24.8037 9.39303 29.445C10.3162 34.0864 12.8202 38.264 16.4783 41.2661C20.1364 44.2682 24.7223 45.9091 29.4545 45.9091V41.1138C25.8317 41.1138 22.3209 39.8576 19.5204 37.5593C16.7199 35.261 14.803 32.0627 14.0962 28.5095C13.3894 24.9563 13.9365 21.2679 15.6443 18.0728C17.3521 14.8778 20.1149 12.3737 23.462 10.9873C26.8091 9.60089 30.5333 9.41792 34.0002 10.4696C37.467 11.5212 40.462 13.7424 42.4747 16.7547C44.4875 19.767 45.3935 23.384 45.0384 26.9894C44.6833 30.5948 43.089 33.9656 40.5273 36.5273L43.9181 39.9181Z",
    fill: "#FEBC2E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3466533",
    d: "M29.2812 41.125H45.0795L49.5695 45.9196H29.2812V41.125Z",
    fill: "#FEBC2E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 634049"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 179",
    x1: 19.6406,
    y1: 21.485,
    x2: 39.0326,
    y2: 21.485,
    stroke: "#66442C",
    strokeWidth: 1.79555
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 180",
    x1: 19.6406,
    y1: 24.7272,
    x2: 39.0326,
    y2: 24.7272,
    stroke: "#66442C",
    strokeWidth: 1.79555
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 182",
    x1: 20.5319,
    y1: 25.25,
    x2: 20.5319,
    y2: 20.9407,
    stroke: "#66442C",
    strokeWidth: 1.79555
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 181",
    x1: 19.6406,
    y1: 29.0397,
    x2: 39.0326,
    y2: 29.0397,
    stroke: "#66442C",
    strokeWidth: 1.79555
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M58.2187 26.0485C58.2187 20.3647 55.8358 15.8349 52.6827 15.2814C52.3162 4.24512 37.7055 0.78125 28.3771 0.78125C19.0488 0.78125 6.46427 4.24606 6.09772 15.2814C2.94544 15.8368 0.5625 20.3647 0.5625 26.0485C0.5625 32.1183 3.28203 36.8739 6.75278 36.8739C10.81 36.8739 10.81 30.6168 10.81 26.0485C10.81 21.8661 10.7997 16.2839 7.68845 15.3671C8.01953 5.33331 19.8946 2.66393 28.3771 2.66393C36.8597 2.66393 50.7617 5.33331 51.0928 15.368C47.9815 16.2849 47.9713 21.867 47.9713 26.0485C47.9713 30.2271 47.9815 35.8027 51.0857 36.7271C50.6947 43.2845 45.7712 47.176 37.7238 47.176C37.6536 47.176 37.5905 47.2033 37.5267 47.223C37.3927 46.9251 37.1938 46.676 36.9509 46.502C36.7081 46.328 36.4304 46.2356 36.1472 46.2346H34.5707C33.7012 46.2346 32.9941 47.079 32.9941 48.1173C32.9941 49.1556 33.7012 50 34.5707 50H36.1472C36.7447 50 37.2587 49.5971 37.5267 49.0116C37.5905 49.0314 37.6536 49.0587 37.7238 49.0587C46.5965 49.0587 52.2263 44.3915 52.6583 36.8193C55.8232 36.2846 58.2187 31.7455 58.2187 26.0485Z",
    fill: "#66442C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssist);
export default __webpack_public_path__ + "static/media/assist.4460d99e2b13e5ff3a734ec7d25e4e5b.svg";
export { ForwardRef as ReactComponent };